import { render } from "./ClubDetails.vue?vue&type=template&id=7e1bbcd7&scoped=true"
import script from "./ClubDetails.vue?vue&type=script&lang=js"
export * from "./ClubDetails.vue?vue&type=script&lang=js"

import "./ClubDetails.vue?vue&type=style&index=0&id=7e1bbcd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1bbcd7"]])

export default __exports__